import { useEffect } from 'react';
import NProgress from 'nprogress';

export function Progress(): null {
  useEffect(() => {
    NProgress.configure({});
    NProgress.start();

    return () => {
      NProgress.done();
    };
  });

  return null;
}
